import { WEEKS } from './constants'

export function getWeekForDate(dateStr) {
  if (!dateStr) return null
  return WEEKS.find(w => dateStr >= w.start && dateStr <= w.end) || null
}

export function getPriceForDate(dateStr, customWeeks) {
  const weeks = customWeeks || WEEKS
  const week = weeks.find(w => dateStr >= w.start && dateStr <= w.end)
  return week ? week.price : 0
}

export function addDays(dateStr, days) {
  // Utilise UTC explicitement pour éviter les décalages DST/timezone
  // (new Date("2026-07-04") est UTC, mais getDate() est local → potentiel off-by-one).
  const [y, m, dd] = String(dateStr).split('T')[0].split('-').map(Number)
  const d = new Date(Date.UTC(y, m - 1, dd + Number(days)))
  return d.toISOString().split('T')[0]
}

// Nombre de jours entre deux dates 'AAAA-MM-JJ' (b - a). UTC → pas de décalage de fuseau.
export function diffJours(a, b) {
  if (!a || !b) return 0
  const [ya, ma, da] = String(a).split('T')[0].split('-').map(Number)
  const [yb, mb, db] = String(b).split('T')[0].split('-').map(Number)
  return Math.round((Date.UTC(yb, mb - 1, db) - Date.UTC(ya, ma - 1, da)) / 86400000)
}

// 'AAAA-MM-JJ' → "6 juillet" (jour + mois, sans année). Lisible dans les récaps admin.
export function fullDate(dateStr) {
  if (!dateStr) return ''
  const [, m, d] = String(dateStr).split('T')[0].split('-')
  const months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
  if (!m || !d) return dateStr
  return `${parseInt(d, 10)} ${months[parseInt(m, 10) - 1]}`
}

export function formatDate(dateStr) {
  if (!dateStr) return ''
  // Handle full ISO format: "2026-08-01T00:00:00.000Z" → "01/08/2026"
  const clean = dateStr.split('T')[0]
  const [y, m, d] = clean.split('-')
  if (!y || !m || !d) return dateStr
  return `${d}/${m}/${y}`
}

export function normalizeDate(dateStr) {
  if (!dateStr) return dateStr
  return dateStr.split('T')[0]
}

export function formatDateLong(dateStr) {
  if (!dateStr) return ''
  return new Date(dateStr).toLocaleDateString('fr-FR', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
  })
}

export function isSaturday(dateStr) {
  const [y, m, d] = String(dateStr).split('T')[0].split('-').map(Number)
  return new Date(Date.UTC(y, m - 1, d)).getUTCDay() === 6
}

export function getSaturdaysInSeason() {
  const saturdays = []
  // Utilise UTC pour éviter les décalages DST/timezone
  let d = new Date(Date.UTC(2026, 5, 27)) // 27 juin 2026 UTC
  const end = new Date(Date.UTC(2026, 7, 31)) // 31 août 2026 UTC
  while (d <= end) {
    if (d.getUTCDay() === 6) saturdays.push(d.toISOString().split('T')[0])
    d.setUTCDate(d.getUTCDate() + 1)
  }
  return saturdays
}
